export default __webpack_public_path__ + "static/media/beeelikegucccy- originals - dolamubadejo bdic  1.289575dd.png";